import { Grid, type GridProps } from '@radix-ui/themes'
import StatBox, { type StatBoxProps } from './stat-box'

type SummaryStatsProps = GridProps & {
  isloading?: boolean
  data: StatBoxProps[]
}
export default function SummaryStats({
  data,
  isloading,
  ...gridProps
}: SummaryStatsProps) {
  return (
    <Grid width='auto' {...gridProps}>
      {data.map((item, index) => (
        <StatBox key={index} {...item} isLoading={isloading} />
      ))}
    </Grid>
  )
}
